import styled from "styled-components";
import { Label as BaseLabel } from "../../ui";

export const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors("background")};
  color: ${({ theme }) => theme.colors("highlight")};
  font-family: 'Silkscreen', monospace;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors("highlight", 0.15)};
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 1.0rem;
  color: ${({ theme }) => theme.colors("highlight")};
`;

export const Body = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const QuestList = styled.div`
  width: 260px;
  flex-shrink: 0;
  border-right: 1px solid ${({ theme }) => theme.colors("highlight", 0.15)};
  overflow-y: auto;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const QuestItem = styled.div`
  padding: 0.4rem 0.6rem;
  cursor: pointer;
  font-size: 0.7rem;
  border: 1px solid ${({ $active, theme }) =>
    $active ? theme.colors("highlight", 0.5) : theme.colors("highlight", 0.12)};
  background: ${({ $active, theme }) =>
    $active ? theme.colors("highlight", 0.08) : "transparent"};
  color: ${({ $active, theme }) =>
    $active ? theme.colors("highlight") : theme.colors("highlight", 0.6)};
  &:hover {
    border-color: ${({ theme }) => theme.colors("highlight", 0.4)};
    color: ${({ theme }) => theme.colors("highlight")};
  }
`;

export const Detail = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1.25rem 1.5rem;
  max-width: 680px;
`;

export const Field = styled.div`
  margin-bottom: 1rem;
`;

export const Label = styled(BaseLabel)`
  display: block;
  font-size: 0.6rem;
  color: ${({ theme }) => theme.colors("highlight", 0.5)};
  text-transform: uppercase;
  margin-right: 0;
  margin-bottom: 0.35rem;
`;

export const StatusBar = styled.div`
  font-size: 0.62rem;
  color: ${({ $err, theme }) =>
    $err ? theme.colors("danger") : theme.colors("success")};
  margin-left: auto;
`;
